export default __webpack_public_path__ + "static/media/TicketStar.3a029169.svg";